module.exports = __webpack_public_path__ + "img/avatar.9a3a77b0.svg";